module.exports = __webpack_public_path__ + "img/titelbild_004_aw.678d4ca4.jpg";